/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type ZerogAddressTokenInfo = {
    TRXHA: string;
    AG: string;
    UT: number;
    BNO: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    AMT: string;
    VAL: string;
    TKNID: string;
    TKNTP: string;
    MTH: string;
    TKNSMR: EvmTokenSummaryInfo;
    TFTP: ZerogAddressTokenInfo.TFTP;
};

export namespace ZerogAddressTokenInfo {

    export enum TFTP {
        IN = 'IN',
        OUT = 'OUT',
    }


}

